module.exports = __webpack_public_path__ + "static/media/user-checklist-bg-bg.268ff5a0.jpg";